export class ReadMore {
    constructor() {
        this.init(document);
    }

    init(context) {
        context.querySelectorAll('[data-read-more]:not(.c-readmore-initialized)').forEach(el => {
            if (el) {
                this.readMoreElement = el;
                this.initialHeight = el.offsetHeight;
                this.readMoreMaxHeight = isNaN(parseInt(el.dataset.readMoreMaxHeight)) ? 0 : parseInt(el.dataset.readMoreMaxHeight);

                if (this.readMoreMaxHeight !== 0 && (this.initialHeight === 0 || this.initialHeight > this.readMoreMaxHeight)) {
                    this.readMoreText = el.dataset.readMore ?? 'Read more';
                    this.readMoreTextOpen = el.dataset.readMoreTextOpen ?? 'Show less';
                    this.readMoreToggle = document.createElement('div');

                    this.readMoreToggle.classList.add('u-read-more-toggle');
                    this.readMoreToggle.textContent = this.readMoreText;

                    this.readMoreElement.classList.add('u-read-more');
                    this.readMoreElement.style.maxHeight = this.readMoreMaxHeight + 'px';
                    this.readMoreElement.after(this.readMoreToggle);

                    this.readMoreElement.classList.add('c-readmore-initialized');

                    this.initToggle(this.readMoreElement, this.readMoreToggle, this.initialHeight, this.readMoreMaxHeight, this.readMoreText, this.readMoreTextOpen);
                } else {
                    console.warn('Read-More Element found but no max-height given or content is not large enough! max-height: ' + this.readMoreMaxHeight + 'px, content-height: ' + this.initialHeight + 'px')
                }
            }
        });
    }

    initToggle(readMoreElement, readMoreToggle, initialHeight, readMoreMaxHeight, readMoreText, readMoreTextOpen) {
        readMoreToggle.addEventListener('click', ev => {
            if (readMoreToggle.classList.contains('u-read-more-toggle--open')) {
                readMoreToggle.classList.remove('u-read-more-toggle--open');
                readMoreToggle.textContent = readMoreText;

                readMoreElement.style.maxHeight = readMoreMaxHeight + 'px';
                readMoreElement.classList.remove('u-read-more--open');
            } else {
                readMoreToggle.classList.add('u-read-more-toggle--open');
                readMoreToggle.textContent = readMoreTextOpen;

                readMoreElement.style.maxHeight = (initialHeight + 200) + 'px';
                readMoreElement.classList.add('u-read-more--open');
            }
        });
    }
}